/**
 * Reports View
 */

import React, { useState } from 'react';
import { FileText, Download, Loader2 } from 'lucide-react';

export default function Reports({ apiUrl }) {
  const [topic, setTopic] = useState('');
  const [loading, setLoading] = useState(false);
  const [report, setReport] = useState(null);

  async function generateReport() {
    if (!topic) return;
    setLoading(true);
    try {
      const response = await fetch(`${apiUrl}/report/generate`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ topic })
      });
      const data = await response.json();
      setReport(data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Report Generation</h1>
        <p className="text-slate-400">Generate comprehensive intelligence reports</p>
      </div>

      <div className="bg-slate-800 rounded-xl p-6 border border-slate-700">
        <div className="flex space-x-4">
          <input
            type="text"
            value={topic}
            onChange={(e) => setTopic(e.target.value)}
            placeholder="Enter report topic..."
            className="flex-1 bg-slate-700 border border-slate-600 rounded-lg px-4 py-3"
          />
          <button
            onClick={generateReport}
            disabled={loading || !topic}
            className="px-6 py-3 bg-cyan-600 hover:bg-cyan-500 rounded-lg font-medium disabled:opacity-50 flex items-center"
          >
            {loading ? <Loader2 className="w-5 h-5 animate-spin mr-2" /> : <FileText className="w-5 h-5 mr-2" />}
            Generate
          </button>
        </div>
      </div>

      {report && (
        <div className="bg-slate-800 rounded-xl p-6 border border-slate-700">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-lg font-semibold">Report: {report.topic}</h2>
            <button className="px-4 py-2 bg-slate-700 rounded-lg flex items-center">
              <Download className="w-4 h-4 mr-2" />
              Export
            </button>
          </div>
          <pre className="bg-slate-900 rounded-lg p-4 text-sm overflow-auto max-h-[600px]">
            {JSON.stringify(report.content || report, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
}
